import { defaultFetchDownload, defaultFetchImport } from './baseApi';

export const downloadEmptyTemplate = (templateName: 'invoices' | 'timesheets') => {
	return defaultFetchDownload(`/v0/templates/statements-${templateName}/emptyexport`);
};

export const importCompiledTemplate = (projectId: string, templateName: 'invoices' | 'timesheets', file: File) => {
	const formData = new FormData();
	formData.append('file', file);
	return defaultFetchImport(`/v0/projects/${projectId}/statements/mass-import/${templateName}`, formData);
};
